/**
 * A path this build does not serve.
 *
 * `routes/index.tsx` had a catch-all inside `/app` and none at the TOP level, so every address that
 * was not `/`, `/auth/*`, `/join`, `/adm` or `/app` fell through to React Router's own development
 * screen — the words "Unexpected Application Error!", "404 Not Found", and a paragraph opening
 * "Hey developer 👋" with advice about adding an `ErrorBoundary` prop.
 *
 * Found in production on 2026-09-15 by typing `/login`, which is what somebody guesses when the real
 * path is `/auth/login`, and again on `/pricing`. Both are addresses a stranger reaches by guessing or
 * from a stale link, which makes the developer screen the first thing some people ever see of this
 * product.
 *
 * Deliberately not a redirect. Bouncing an unknown address to `/app` would send a signed-out visitor
 * to the login screen with no explanation of why their link did not work, and would hide a broken
 * link from whoever published it.
 */
import { Link } from 'react-router-dom'
import { Card, ErrorState } from '@flowza/ui'

export default function NotFound() {
  return (
    <div className="mx-auto max-w-2xl px-4 py-12">
      <Card>
        <ErrorState
          title="That page does not exist"
          body="The address may be mistyped, or the page may have moved. If you followed a link to sign a document, open the link from your email again — a signing link is personal to you and cannot be reached from here."
        />
        <div className="mt-4">
          <Link
            to="/app"
            className="border-border-strong text-text-primary hover:bg-surface-sunken h-control inline-flex items-center rounded-md border px-3 text-sm font-medium no-underline"
          >
            Go to FlowZa Sign
          </Link>
        </div>
      </Card>
    </div>
  )
}
